import { FilterChipsBar } from './FilterChipsBar';
import { useCreatorFilterChips } from '@/hooks/useFilterChips';

/**
 * Filters Indicator (Creator)
 *
 * Shows when user has active search/filters applied to posts.
 * Chips come from the shared useCreatorFilterChips (SSOT with ActiveStatesIndicator).
 */
export const FiltersIndicator = () => {
  const { chips, clearAll } = useCreatorFilterChips();
  return <FilterChipsBar chips={chips} onClearAll={clearAll} />;
};
